import envConfig from '../../static/config';
import {
  handlePaymentHistorySMESuccess,
  handlePaymentHistorySMEFailure,
  handlePaymentHistorySuccessForCreator,
  handlePaymentHistoryFailureForCreator,
} from '../actions/PaymentsHistorySMEActionCreator';
import ApiUtils from './ApiUtils';

const _getPaymentHistoryListUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/paymenthistory/searches';
const _getPaymentHistoryCreatorUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/paymenthistory/searches/user';

export const getPaymentHistorySME = (requestData) => {
  const url = envConfig.apiBaseUrlPAAS + _getPaymentHistoryListUrl;
  const method = 'POST';
  ApiUtils.makeAjaxCall(
    {
      apiVersion: '1.3.0',
      method,
      url,
      addAuthToken: true,
      requestData,
    },
    (body) => {
      handlePaymentHistorySMESuccess(body);
    },
    (error, status) => {
      handlePaymentHistorySMEFailure(error && error.error, status);
    }
  );
};

export const getPaymentHistoryForCreator = (requestData) => {
  const url = envConfig.apiBaseUrlPAAS + _getPaymentHistoryCreatorUrl;
  ApiUtils.makeAjaxCall(
    {
      apiVersion: '1.3.0',
      method: 'POST',
      url,
      addAuthToken: true,
      requestData,
    },
    (body) => {
      handlePaymentHistorySuccessForCreator(body);
    },
    (error, status) => {
      handlePaymentHistoryFailureForCreator(error.error, status);
    }
  );
};
